import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CriarNotaFiscal.css";

export default function EmitirNotaFiscal() {
  const { id } = useParams(); // Pega o ID da cobrança da URL
  const navigate = useNavigate();
  const [cobranca, setCobranca] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    if (!id) {
      setMensagem("Nenhuma cobrança selecionada.");
      setTimeout(() => navigate("/financeiro"), 2000); // Redireciona para lista de cobranças
      return;
    }

    async function fetchCobranca() {
      try {
        const response = await fetch(
          `https://welaunchyou.com.br/crm-wly/api/financeiro/detalhes_cobranca.php?id=${id}`
        );
        const data = await response.json();

        if (!data || data.error) {
          setMensagem("Cobrança não encontrada.");
          setTimeout(() => navigate("/financeiro"), 2000);
        } else {
          setCobranca(data);
        }
      } catch (error) {
        setMensagem("Erro ao buscar cobrança.");
        setTimeout(() => navigate("/financeiro"), 2000);
      }
    }

    fetchCobranca();
  }, [id, navigate]);

  const handleEmitirNota = async () => {
    if (!id) return;

    setLoading(true);
    setMensagem("");

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/criar_nota_asaas.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_cobranca: Number(id) }),
        }
      );
      const data = await response.json();
      console.log("Resposta do backend:", data); // 👀 Veja a resposta completa


      if (data.success) {
        setMensagem(`Nota criada com sucesso! ID da Nota: ${data.invoice.id}`);
      } else {
        setMensagem(`Erro: ${data.error || data.details?.message}`);
      }
    } catch (error) {
      setMensagem(`Erro de rede: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="emitir-nota-container">
      <h2>Emitir Nota Fiscal</h2>

      {!cobranca ? (
        <p>{mensagem || "Carregando detalhes da cobrança..."}</p>
      ) : (
        <>
          <p><strong>Cliente:</strong> {cobranca.cliente}</p>
          <p><strong>Valor:</strong> R$ {parseFloat(cobranca.valor).toFixed(2)}</p>
          <p><strong>Vencimento:</strong> {cobranca.vencimento}</p>

          <button onClick={handleEmitirNota} disabled={loading}>
            {loading ? "Gerando Nota..." : "Gerar Nota"}
          </button>

          {mensagem && <p className="status-message">{mensagem}</p>}
        </>
      )}
    </div>
  );
}
